import { useContext } from 'react';
import { Icon, ModalContainer, ModalContent, Overlay, Title } from 'ui/styled';
import {
  CloseContainer,
  CompanyDataContainer,
  ContainerColumn,
} from './styled';

import { CoreContext } from 'context/CoreContext';

export default function WrapperTwoCol({
  children,
  children2,
  footer,
  onClose,
  title = null,
  titleColumn1 = null,
  titleColumn2 = null,
  width,
}) {
  const { setModal } = useContext(CoreContext);
  //adiciona funcionalidade de fechar ao clicar fora do modal via prop ou contexto
  const close = () => {
    //agora permti passar via func de fechamento externa
    if (typeof onClose === 'function') {
      onClose();
    } else {
      setTimeout(async () => {
        setModal(null);
      }, 500);
    }
  };

  const handleClose = (e) => {
    const mc = document.getElementById('modal-content');
    if (!mc?.contains(e?.target) && !(e?.target.tagName === 'LI')) {
      //Desabilidado funcionalidade de fechar o modal ao clicar fora
      //close();
    }
  };

  return (
    <Overlay onClick={handleClose}>
      <ModalContainer>
        <ModalContent id="modal-content" width={width || '60vw'}>
          <CompanyDataContainer>
            <CloseContainer>
              <Title nomargin>{title ? title : 'Oferta'}</Title>
              <Icon icon={'close-big'} pointer={true} onClick={close} />
            </CloseContainer>
          </CompanyDataContainer>
          <CompanyDataContainer>
            <ContainerColumn>
              <Title nomargin small>
                {titleColumn1 ? titleColumn1 : 'Oferta'}
              </Title>
              {children}
            </ContainerColumn>
            {children2 && (
              <ContainerColumn>
                <Title nomargin small>
                  {titleColumn2 ? titleColumn2 : 'Oferta'}
                </Title>
                {children2}
              </ContainerColumn>
            )}
          </CompanyDataContainer>
          {footer && <CompanyDataContainer>{footer}</CompanyDataContainer>}
        </ModalContent>
      </ModalContainer>
    </Overlay>
  );
}
